import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { FiArrowRight, FiCalendar } from 'react-icons/fi';
import blogPosts from '../data/blogPosts';
import './BlogIndex.css';

const formatDate = (iso) => {
  const d = new Date(iso);
  return d.toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' });
};

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    { "@type": "ListItem", "position": 1, "name": "Accueil", "item": "https://limousine-vip-paris.fr/" },
    { "@type": "ListItem", "position": 2, "name": "Blog", "item": "https://limousine-vip-paris.fr/blog" }
  ]
};

const blogSchema = {
  "@context": "https://schema.org",
  "@type": "Blog",
  "name": "Blog VIP Limousine Paris",
  "url": "https://limousine-vip-paris.fr/blog",
  "description": "Conseils, guides et inspirations sur la location de limousine à Paris : mariage, EVJF, transferts aéroport, voitures de luxe.",
  "blogPost": blogPosts.map((p) => ({
    "@type": "BlogPosting",
    "headline": p.title,
    "url": `https://limousine-vip-paris.fr/blog/${p.slug}`,
    "datePublished": p.publishedDate,
    "image": `https://limousine-vip-paris.fr${p.image}`,
    "author": { "@type": "Organization", "name": p.author }
  }))
};

const BlogIndex = () => {
  return (
    <article className="blog-index">
      <Helmet>
        <title>Blog VIP Limousine Paris - Guides, Conseils & Tarifs Limousine</title>
        <meta name="description" content="Le blog VIP Limousine Paris : guides tarifs, top des lieux, conseils mariage, comparatifs taxi/Uber, idées EVJF. Articles d'experts pour vos événements en limousine." />
        <link rel="canonical" href="https://limousine-vip-paris.fr/blog" />
        <meta property="og:title" content="Blog VIP Limousine Paris" />
        <meta property="og:description" content="Guides et conseils pour louer une limousine à Paris." />
        <meta property="og:url" content="https://limousine-vip-paris.fr/blog" />
        <meta property="og:type" content="website" />

        <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script>
        <script type="application/ld+json">{JSON.stringify(blogSchema)}</script>
      </Helmet>

      <header className="blog-index-hero">
        <div className="container">
          <nav className="seo-breadcrumb" aria-label="Fil d'Ariane">
            <Link to="/">Accueil</Link>
            <span> › </span>
            <span>Blog</span>
          </nav>
          <span className="section-badge">Le Blog</span>
          <h1>Blog VIP Limousine Paris</h1>
          <p className="blog-index-subtitle">
            Guides tarifs, conseils mariage, comparatifs transport, idées EVJF — tout ce
            que vous devez savoir pour vos événements en limousine à Paris.
          </p>
        </div>
      </header>

      <div className="blog-index-list container">
        {blogPosts.map((post) => (
          <Link key={post.slug} to={`/blog/${post.slug}`} className="blog-card">
            <div className="blog-card-image">
              <img src={post.image} alt={post.imageAlt} loading="lazy" width="800" height="600" />
            </div>
            <div className="blog-card-content">
              <div className="blog-card-meta">
                <FiCalendar size={14} />
                <span>{formatDate(post.publishedDate)}</span>
              </div>
              <h2 className="blog-card-title">{post.title}</h2>
              <p className="blog-card-excerpt">{post.excerpt}</p>
              <span className="blog-card-readmore">
                Lire l'article <FiArrowRight />
              </span>
            </div>
          </Link>
        ))}
      </div>
    </article>
  );
};

export default BlogIndex;
